import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { NavBar, Footer, VocabularyRender } from "../../components";
import configuration from "../../../package.json";
import { AudioWavePlayer } from "../../components/dictionary/AudioWavePlayer";
import { SubtitlePlayer } from "../../components/dictionary/SubtitlePlayer";
import { OpenSearch } from "aws-sdk";

export const Listening = (props) => {
  const { homepage , soundPath , srtPath } = configuration;
  const localtion = useLocation();
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [list, setList] = useState([]);
  const [title, setTitle] = useState([]);
  const [sound, setSound] = useState("");
  const [srt, setSrt] = useState("");
  const [letters, setLetters] = useState([]);
  const [letterSort, setLetterSort] = useState(true);
  const [haseImages, setHasImages] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [currentAudioTime, setCurrentAudioTime] = useState(0);

  useEffect(() => {
    if (localtion.state) {
      setList(localtion.state.items);
      setTitle(localtion.state.title);
      setSound(localtion.state.sound || "");
      setSrt(localtion.state.srt);
      setLetterSort(localtion.state.lettersort);
      setHasImages(localtion.state.images);
      // console.log();
    } else {
      navigate(`${homepage}`);
    }
    let letters_ = [];
    for (let i = 65; i <= 90; i++) {
      letters_.push(String.fromCharCode(i));
    }
    setLetters(letters_);

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getBackgroundStyle = () => ({
    backgroundImage: `url('/icons/pattern.svg')`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: isMobile ? "left top" : "right top",
    backgroundSize: isMobile ? "250%" : "contain",
  });

  return (
    <div className="flex w-full max-w-screen min-h-screen p-0 m-0 flex-col gap-2 overflow-hidden md:max-w-[875px] md:m-auto">
      <NavBar title={title.phrase} backto={-1} search={true} />
      <div className="w-full flex flex-col p-0 top-16 relative">
        {title.subtitle ? (
          <div className="flex w-full mb-5 text-center items-center justify-center rounded-b-lg text-white bg-gray-600 self-center py-3 text-2xl font-bold">
            {title.subtitle}
          </div>
        ) : (
          <div className="flex w-full mb-5 text-center items-center justify-center rounded-b-lg text-white self-center py-3 text-2xl font-bold"></div>
        )}
        <div className="grid grid-cols-6 gap-2 bg-white rounded-lg ">
          <div className="col-span-4 md:col-span-3  flex flex-col justify-center ps-4 md:ps-10 py-4 -me-[30%] md:me-0">
            <div className="text-lg font-bold mb-2 pe-4 md:pe-8">
              <img
                src="/logos/logo_3.svg"
                alt="Listening"
                className="inline mr-2 w-[80%]"
              />
            </div>
            {sound ? (
              <>
                <AudioWavePlayer
                  ref={audioRef}
                  audioUrl={`${sound}`}
                  onTimeUpdate={(time) => setCurrentAudioTime(time)}
                  audioRef={audioRef}
                />
                {srt && (
                  <SubtitlePlayer
                    subtitleFile={`${srt}`}
                    currentTime={currentAudioTime}
                    audioRef={audioRef}
                  />
                )}
              </>
            ) : (
              <div style={{ color: "red" }}>No audio file specified</div>
            )}
          </div>
          <div
            className={`listening-container min-h-[250px] h-full col-span-2 md:col-span-3 flex flex-row justify-end rounded-lg opacity-30 md:opacity-100`}
            style={getBackgroundStyle()}
          ></div>
        </div>
      </div>
      <div className="h-24" />
      <Footer />
    </div>
  );
};
